export default __webpack_public_path__ + "static/media/logo.8b1f4e2e.png";